import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableApiSettingsRestrictions = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableApiSettingsRestrictions);
};
